import { Button } from '@material-ui/core';
import React, { Fragment } from 'react';

const MainMenu = ({ handleQR }) => {
 
	 return (
		 <Fragment>
			 <Button onClick={handleQR} variant="contained" color="primary">
				 Scanner un code QR
			 </Button>
		 </Fragment>
	 );
}

MainMenu.defaultProps = {
	handleQR: null
}

export default MainMenu;